import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/parker-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Parker", "parker"),
  component: () => (
    <CityDigitalMarketingPage
      city="Parker"
      slug="parker"
      intro="Parker is a high-income, fast-growing south Denver metro market where local trades, professional services, and retail compete hard for visibility. We help Parker businesses win the Map Pack, dominate organic Google, and get cited by ChatGPT and Google AI Overviews."
      whyUs={[
        "Neighborhood-deep SEO for Stonegate, Stroh Ranch, Pinery, and Idyllwilde",
        "We compete with Denver-metro agencies on quality, not on bloated retainers",
        "Direct line to Chris, the owner — every Parker client gets owner-led strategy",
      ]}
      nearby={[
        { name: "Castle Rock", to: "/castle-rock-digital-marketing" },
        { name: "Aurora", to: "/aurora-digital-marketing" },
        { name: "Denver", to: "/denver-digital-marketing" },
        { name: "Centennial", to: "/centennial-seo" },
        { name: "Colorado Springs", to: "/colorado-springs" },
      ]}
      testimonial={{
        quote:
          "We were invisible in Parker before working with Chris. Now we show up in the Map Pack for almost every search that matters to our business.",
        role: "Service Business Owner",
        city: "Parker",
      }}
      industryLinks={industryLinksFor("Parker")}
    />
  ),
});
